import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';
import { BlockNames } from './block.types';

export function addBlock(piletApi: PiletApi) {
	const LazyPageBlock = React.lazy(() => import('./PageBlock'));
	piletApi.registerExtension(BlockNames.Page, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyPageBlock {...props} />
		</React.Suspense>
	));

	const LazyClientAppWithNavigationZones = React.lazy(
		() => import('./ClientAppWithNavigationZonesBlock')
	);
	piletApi.registerExtension(BlockNames.WithNavigationZones, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyClientAppWithNavigationZones {...props} />
		</React.Suspense>
	));

	const LazyFallbackClientApp = React.lazy(() => import('./FallbackClientApp'));
	piletApi.registerExtension(BlockNames.FallbackClientApp, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyFallbackClientApp {...props} />
		</React.Suspense>
	));

	const LazyFilesWithBackgroundBlock = React.lazy(
		() => import('./FilesWithBackgroundBlock')
	);
	piletApi.registerExtension(BlockNames.FilesWithBackground, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyFilesWithBackgroundBlock {...props} />
		</React.Suspense>
	));
}
